import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { Page } from "../components/Reveal";

const NotFound = () => {
  const { t } = useLang();
  return (
    <Page>
      <section className="flex min-h-[70vh] flex-col items-center justify-center bg-cream px-5 pt-28 text-center" data-testid="not-found">
        <p className="font-script text-5xl text-rosedeep">Bloom</p>
        <h1 className="mt-4 font-serif text-4xl font-semibold text-ink sm:text-5xl">{t.notFound.title}</h1>
        <p className="mt-4 max-w-md text-ink/60">{t.notFound.p}</p>
        <Link
          to="/"
          data-testid="not-found-home"
          className="mt-8 rounded-full bg-rosedeep px-7 py-3.5 text-[12px] font-bold uppercase tracking-[0.16em] text-white transition-colors hover:bg-ink"
        >
          {t.notFound.cta}
        </Link>
      </section>
    </Page>
  );
};

export default NotFound;
